import type { CurrentUser } from '@/types/auth';
import type { AppRouteNode } from '@/types/route';

type AccessInitialState = {
  currentUser?: CurrentUser;
};

const canAccessRoute = (
  route: Pick<AppRouteNode, 'roles' | 'permissions'> | undefined,
  currentUser?: CurrentUser,
) => {
  if (!route || !currentUser) {
    return false;
  }

  const rolePassed =
    !route.roles?.length ||
    route.roles.some((role) => currentUser.roles.includes(role));
  const permissionPassed =
    !route.permissions?.length ||
    route.permissions.every((permission) =>
      currentUser.permissions.includes(permission),
    );

  return rolePassed && permissionPassed;
};

export default function access(initialState: AccessInitialState | undefined) {
  const currentUser = initialState?.currentUser;

  return {
    isLoggedIn: Boolean(currentUser),
    canAdmin: currentUser?.roles.includes('admin') ?? false,
    hasRole: (role: string) => currentUser?.roles.includes(role) ?? false,
    hasPermission: (permission: string) =>
      currentUser?.permissions.includes(permission) ?? false,
    canAccessRoute: (route?: Pick<AppRouteNode, 'roles' | 'permissions'>) =>
      canAccessRoute(route, currentUser),
  };
}
